export enum PondStatus {
  active = 'active',
  inactive = 'inactive',
}

export enum PondType {
  Production = 'production',
  Nursery = 'nursery',
  Raceway = 'raceway', // zoom zoom? 👀
}

export interface PondState {
  statusDate: string;
  ponds: Pond[];
}

export enum RegistrationDateType {
  setup = 'registrationSetupDate',
  overview = 'registrationDate',
  log = 'registrationLogDate',
}

export interface Pond {
  currentQty: number;
  currentMw: number;
  targetQty: number;
  targetMw: number;
  cycleId: number;
  cycleName: string;

  pondId: string;
  siteId: string;
  zoneId: string;
  pondName: string;
  siteName: string;
  zoneName: string;
  createdBy: string;
  pondType: PondType;
  latitude: number | null;
  longitude: number | null;
  size: number;
  depth: number;

  // seacloud fields
  pondStatus: PondStatus;
  activeInactiveDays: number;
  allowStocking: boolean;
  allowTransfer: boolean;
  allowHarvest: boolean;
  allowOtherRegistrations: boolean;

  // lock status
  lockCreatedBy: string;
  lockExpiresIn: string | null;

  // aerators and feeders
  totalNrOfAerators: number;
  totalAeratorSupportedBiomass: number;
  totalNrOfFeeders: number;
  totalBiomassFeedingCapacity: number;
  totalBiomassInKg: number;
  aeratorSupportedBiomassPercentage: number;
  feederSupportedBiomassPercentage: number;
}
